import {
  ContentPart,
  ContentPartType,
} from 'common/builder/components/chart/FlowChart/hooks/useTextContentParts'

export function getContentPartKey(contentPart: ContentPart, index: number): string {
  if (contentPart.type === ContentPartType.TEXT) {
    return `${contentPart.text}_${index}`
  }

  if (contentPart.type === ContentPartType.BUTTON) {
    return contentPart.buttonId
  }

  return index.toString()
}
